export default __webpack_public_path__ + "static/media/flag-button-inactive@2x.31d8ac20.png";